import { render } from "./PaymentConfigDefaultValue.vue?vue&type=template&id=74d525d9"
import script from "./PaymentConfigDefaultValue.vue?vue&type=script&lang=js"
export * from "./PaymentConfigDefaultValue.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__